<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <TableLoading v-if="role.publicId === '0'"/>
    <div v-else class="row">
      <div class="row">
        <h3 class="my-3 ml-2">{{role.name}}</h3>
        <div class="col-lg-7">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Users</h4></div>
            <div class="px-4 pb-4">
              <data-table :columns="columns" :rows="role.usersPaginated.objects">
                <template v-slot:actions="slotProps" v-if="checkForPermission(remove_user_from_role_permission)">
                  <b-button variant="danger" size="sm" class="py-1 text-white" @click="removeUserfromRole(slotProps.row.publicId)">Remove</b-button>
                </template>
              </data-table>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card mb-4" v-if="checkForPermission(view_single_user_role_permission_details_permission)">
            <div class="card-body">
              <h4 class="card-title mb-4">Permissions</h4>
              <div class="table-responsive">
                <table class="table table-nowrap align-mid table-hover mb-0">
                  <tbody>
                  <tr v-for="permission in role.permissions" :key="permission.id">
                    <td>
                      <h5 class="text-truncate font-size-14 mb-1">
                        <a href="javascript: void(0);" class="text-dark">
                          {{permission.name}}
                        </a>
                      </h5>
                      <p class="text-muted mb-0">{{ permission.codename }}</p>
                    </td>
                    <td style="width: 90px;vertical-align: bottom" v-if="checkForPermission(remove_permission_from_role_permission)">
                      <div>
                        <ul class="list-inline mb-0 font-size-20">
                          <li class="list-inline-item" @click="removePermissionFromRole(permission.id)">
                            <a
                                href="javascript: void(0);"
                                class="text-primary p-1"
                            >
                              <i class="bx bxs-trash"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="card mt-4">
            <div class="card-body">
              <h4 class="card-title mb-4">Dashboard Components</h4>
              <div class="table-responsive">
                <table class="table table-nowrap align-mid table-hover mb-0">
                  <tbody>
                  <tr v-for="widget in role.widgets" :key="widget.id">
                    <td>
                      <h5 class="text-truncate font-size-14 mb-1">
                        <a href="javascript: void(0);" class="text-dark">
                          {{ widget.widget }}
                        </a>
                      </h5>
                    </td>
                    <td style="width: 90px;vertical-align: bottom" v-if="checkForPermission(remove_widget_from_role_permission)">
                      <div>
                        <ul class="list-inline mb-0 font-size-20">
                          <li class="list-inline-item" @click="removeDashboardWidgetFromRole(widget.id)">
                            <a
                                href="javascript: void(0);"
                                class="text-secondary p-1"
                            >
                              <i class="bx bxs-trash"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import DataTable from "@/components/data-table";
import {SINGLE_USER_ROLE} from "@/gql";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";

export default {
  page: {
    title: "Single User Role",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, DataTable, PageHeader, Layout},
  name: "single-user-role",
  data() {
    return {
      title: "Single User Role",
      items: [
        {
          text: "User Roles",
          href: routeItems.user_roles_route
        },
        {
          text: "Single User Role",
          active: true
        }
      ],
      view_single_user_role_permission_details_permission: permissions.view_single_user_role_permission_details_permission,
      remove_permission_from_role_permission: permissions.remove_permission_from_role_permission,
      remove_user_from_role_permission: permissions.remove_user_from_role_permission,
      remove_widget_from_role_permission: permissions.remove_widget_from_role_permission,
      role: {
        publicId: '0',
        name: "",
        permissions: {},
        usersPaginated: {
          objects: []
        },
        widgets: [{
          id: "",
          widget: ""
        }]
      },
      searchTerm: "",
      columns: [
        {
          field: 'name',
          label: 'Name'
        },
        {
          field: 'email',
          label: 'Email'
        },
        {
          field: 'phoneNumber',
          label: 'Phone Number'
        },
        {
          field: 'isActive',
          label: 'User Status'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ],
      single_user_role: SINGLE_USER_ROLE
    }
  },
  apollo: {
    role: {
      query: SINGLE_USER_ROLE,
      variables(){
        return{
          id: parseInt(this.$route.params.id)
        }
      }
    }
  },
  methods: {
    ... mapActions({
      deleteUserFromRole: 'user/deleteUserFromRole',
      deletePermissionFromRole: 'user/deletePermissionFromRole',
      deleteWidgetFromRole: 'user/deleteWidgetFromRole'
    }),
    async removeUserfromRole(userId){
      const data = {'userId': userId, 'roleId': parseInt(this.$route.params.id)}
      await this.deleteUserFromRole(data).then(resp => {
        if(resp.message){
          this.$apollo.queries.role.refetch()
          successToast(`${resp.message}`)
        }
      })
    },
    async removePermissionFromRole(permissionId){
      const data = {'permissionId': parseInt(permissionId), 'roleId': parseInt(this.$route.params.id)}
      await this.deletePermissionFromRole(data).then(resp => {
        if(resp.message){
          this.$apollo.queries.role.refetch()
          successToast(`${resp.message}`)
        }
      })
    },
    async removeDashboardWidgetFromRole(widgetId){
      const data = {'id': parseInt(widgetId)}
      await this.deleteWidgetFromRole(data).then(resp => {
        if(resp.message){
          this.$apollo.queries.role.refetch()
          successToast(`${resp.message}`)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
